import { useCallback } from "react";
import { customToast } from "../../../components/Toast";

export const useCopyClipBoard = () => {
  const copyToClipBoard = useCallback(async (data, message = 'Dado copiado com sucesso') => {
    try {
      await navigator.clipboard.writeText(data);
      customToast(message, 'success');
    } catch (err) {
      customToast('Erro ao copiar', 'error');
    }
  }, []);

  return copyToClipBoard;
};